<template>
  <div class="login-container">
    <h2>Redmine Admin Login</h2>
    <form @submit.prevent="handleLogin">
      <div class="form-group">
        <label>Username</label>
        <input v-model="username" type="text" required>
      </div>
      <div class="form-group">
        <label>Password</label>
        <input v-model="password" type="password" required>
      </div>
      <button type="submit" :disabled="loading">Login</button>
      <p v-if="error" class="error">{{ error }}</p>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: ''
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true
      this.error = ''
      
      try {
        const { data } = await this.$axios.post('/api/login', {
            username: this.username,
            password: this.password
          }
        )

        if (!data.success) {
          throw new Error(data.error || 'Login failed')
        }

        // Store user info
        localStorage.setItem('user', JSON.stringify(data.user))
        
        // Redirect to home
        this.$router.push('/')
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
}
.form-group {
  margin-bottom: 15px;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue